import Sidebar from "../Sidebar/Sidebar";
import UsersManagementStep from "./UsersManagementStep";
import { Container } from "./UsersManagementStyles";

export const UsersManagementSidebar = (props) => {
  const {
    toggleModal,
    loadUsers,
    dataUserEdit,
    showModalHide,
    showModalEdit,
    userCompanyMe,
    userProfileMe,
    setMessageTypeEditCreate,
    settitleTypeEditCreate,
    showProfileTwoShowUser,
    userInfo,
  } = props;

  return (
    <Sidebar onOutsideClick={() => toggleModal()}>
      <Container>
        <UsersManagementStep
          loadUsers={loadUsers}
          toggleModal={toggleModal}
          dataUserEdit={dataUserEdit}
          showModalEdit={showModalEdit}
          showModalHide={showModalHide}
          userCompanyMe={userCompanyMe}
          userProfileMe={userProfileMe}
          setMessageTypeEditCreate={setMessageTypeEditCreate}
          settitleTypeEditCreate={settitleTypeEditCreate}
          userInfo={userInfo}
          showProfileTwoShowUser={showProfileTwoShowUser}
        />
      </Container>
    </Sidebar>
  );
};
export default UsersManagementSidebar;
